import ServiceExec from '@/common/utils/ServiceExec';
import { church } from '@/common/service/apiList';
import store from '@/store';
const { searchChurch, applyChurch, getChurch } = church;

export default {
  searchChurch: async ({ commit, getters, state }, payload) => {
    const { page, limit } = state.condition;
    state.condition.searchText = payload;
    const { data, status } = await ServiceExec.get(searchChurch, {
      ...state.condition
    });
    if (status !== ServiceExec.status.OK) return false;
    commit('setChurchList', data.list ?? []);
  },
  applyChurch: async ({ commit, state }, payload) => {
    const { userNo } = store.getters['user/getUserData'];
    payload.userNo = userNo;
    const { status, data } = await ServiceExec.patch(applyChurch, payload);
    if (status !== ServiceExec.status.OK || !data) return false;

    store.commit('user/setChurchInfo', data);
    return data;
  },
  getChurch: async () => {
    const userData = store.getters['user/getUserData'];
    const { status, data } = await ServiceExec.get(getChurch(userData.churchNo));
    if (status !== ServiceExec.status.OK) return false;

    userData.churchName = data.churchName;
    return data;

    // store.commit('user/setUserData', userData);
  }
};
